/* eslint-disable */
import React from 'react';
import { Box, Stack, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import CircleIcon from '@mui/icons-material/Circle';

import { createTheme } from '@mui/material/styles';
const theme = createTheme();


const useStyles = makeStyles(() => ({
    fontSize: {
        fontSize: 20,
    },
    wrapper: {
        position: 'relative',
        display: 'inline-flex',
        justifyContent: 'center',
        alignItems: 'center',
        cursor: 'pointer',
    },
    icon: {
        fontSize: '1.5em',
    },
    count: {
        position: 'absolute',
        color: '#fff',
        fontWeight: 500,
        fontSize: '0.65em',
    },
}));

const UserMediaCircuit = (props) => {
    const { value, header } = props;

    const classes = useStyles();
    return (
        <>
            {!header ? (
                <HeaderModuleCount
                    props={props}
                    countValue={value}
                    showTotalCount={false}
                />

            ) : (
                <> 
                    <HeaderModuleCount
                        props={props}
                        countValue={props.column.userCount}
                        showTotalCount={true}
                    />
                    <HeaderModuleCount
                        props={props}
                        countValue={props.column.allRequests}
                        showTotalCount={true}
                    />
                </> 
            )}
        </>
    );
};
const HeaderModuleCount = ({ props, countValue, showTotalCount }) => {
    const classes = useStyles();
    let parsedCounts = {};
    try {
        parsedCounts = showTotalCount ? JSON.parse(countValue) : countValue;
    } catch (e) {
        console.error('Invalid JSON:', countValue);
    }

    return (
        <Box display="flex" flexDirection="row">
            <Stack spacing={1} direction="row">
                {showTotalCount ? <Box className={classes.wrapper} style={{ fontSize: 16 }} title={`Total: ${parsedCounts.total ?? 0}`}
                    onClick={(event) => props.onHeaderTotalClick(props.colIndex, props.column, 'total')}>
                    <CircleIcon className={classes.icon} style={{ color: theme.palette.grey[600] }} />
                    <Typography component="span" className={classes.count}>
                        {parsedCounts.total ?? 0}
                    </Typography>
                </Box> : <Box className={classes.wrapper} style={{ fontSize: 16, width: '24px' }}>&nbsp; </Box>} 
                <Box className={classes.wrapper} style={{ fontSize: 16 }}
                    title={`To Do: ${(Number(parsedCounts.rejected ?? 0) + Number(parsedCounts.todo ?? 0))}`}
                    onClick={(event) =>
                        props.setUserHeadPermission(
                            props.colIndex,
                            props.column,
                            'todo'
                        )
                    }>
                    <CircleIcon className={classes.icon} style={{ color: theme.palette.error.main }} />
                    <Typography component="span" className={classes.count}>
                        {(Number(parsedCounts.rejected ?? 0) + Number(parsedCounts.todo ?? 0))}
                    </Typography>
                </Box>
                <Box className={classes.wrapper} style={{ fontSize: 16 }}
                 title={`Pending: ${parsedCounts.inprogress ?? 0}`}
                    onClick={(event) =>
                        props.setUserHeadPermission(
                            props.colIndex,
                            props.column,
                            'inprogress'
                        )
                    }>
                    <CircleIcon className={classes.icon} style={{ color: '#bc8d15' }} />
                    <Typography component="span" className={classes.count}>
                        {parsedCounts.inprogress ?? 0}
                    </Typography>
                </Box>
                <Box className={classes.wrapper} style={{ fontSize: 16 }}
                title={`Approved: ${parsedCounts.approved ?? 0}`}
                    onClick={(event) =>
                        props.setUserHeadPermission(
                            props.colIndex,
                            props.column,
                            'approved'
                        )
                    }>
                    <CircleIcon className={classes.icon} style={{ color: theme.palette.success.main }} />
                    <Typography component="span" className={classes.count}>
                        {parsedCounts.approved ?? 0}
                    </Typography>
                </Box>
            </Stack>
        </Box>
    );
};

export default UserMediaCircuit;
